import { QidCompany } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setQidCompanyList = (companyList: types.QidCompanyList) => ({
    type: inferLiteral(types.QID_COMPANY_LIST),
    companyList,
})
export const setQidCompanyIds = (companyIds: readonly number[]) => ({
    type: inferLiteral(types.QID_COMPANY_IDS),
    companyIds,
})
export const setQidCompanyView = (company: QidCompany) => ({
    type: inferLiteral(types.QID_COMPANY_VIEW),
    company,
})
export const setQidCompanyEdit = (company: QidCompany) => ({
    type: inferLiteral(types.QID_COMPANY_EDIT),
    company,
})
export const setQidCompanySort = (sortColumn: keyof QidCompany, sortOrder: OrderType) => ({
    type: inferLiteral(types.QID_COMPANY_SORT),
    sortColumn,
    sortOrder,
})
export const setQidCompanyFilters = (filters: types.QidCompanyFilters) => ({
    type: inferLiteral(types.QID_COMPANY_FILTERS),
    filters,
})
export const setQidCompanyReloadList = (value: boolean) => ({
    type: inferLiteral(types.QID_COMPANY_RELOAD_LIST),
    value,
})
export const setQidCompanyReloadView = (value: boolean) => ({
    type: inferLiteral(types.QID_COMPANY_RELOAD_VIEW),
    value,
})
export const setQidCompanyReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.QID_COMPANY_RELOAD_EDIT),
    value,
})
